import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-faktura',
  templateUrl: './faktura.component.html',
})
export class FeaturePreviewFaktura extends FeaturePreviewComponent {}
